import { Badge } from 'antd';
import React from 'react';
import { Props } from './index';
import { RoleEnum, VerificationsClient, VerificationStatusEnum } from '../../utils/api';

interface State {
    noOfUnverifiedVerifications: number
}

class VerificationBadge extends React.Component<Props, State> {
    private intervalId: NodeJS.Timeout | null = null;

    public constructor(props: Props) {
        super(props);

        this.state = {
            noOfUnverifiedVerifications: 0
        };
    }

    componentDidMount = async () => {
        await this.getNumberOfUnverifiedVerifications();

        this.intervalId = setInterval(async () => {
            await this.getNumberOfUnverifiedVerifications();
        }, 60000);
    }

    componentWillUnmount() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }

    async getNumberOfUnverifiedVerifications() {
        const { userRole } = this.props;

        if (userRole !== RoleEnum.SiteManager) return;

        const verifications = await new VerificationsClient().getAll(
            null,
            null,
            undefined,
            null,
            null,
            null,
            null,
            null,
            null
        );

        this.setState(
        {
            noOfUnverifiedVerifications: verifications.filter(v => v.verificationStatusId === VerificationStatusEnum.Unverified).length
        });
    }

    public render(): React.ReactElement {
        const {
            userRole,
        } = this.props;

        const { noOfUnverifiedVerifications } = this.state;

        return (
            (userRole === RoleEnum.SiteManager) ?
                <Badge count={noOfUnverifiedVerifications} size="small" style={{ marginLeft: 8 }} />
                : <></>
        );
    }
}

export default VerificationBadge;
